import React from 'react';
import { Sparkles, Gift, ArrowRight, Heart, Baby, Cake, GraduationCap, Plane, Lightbulb, Cloud, Stethoscope, LifeBuoy, AlertTriangle, Users, HandHeart } from 'lucide-react';
import { joyeuseCategories, yakoCategories } from '../mock';
import { useAuth } from '../context/AuthContext';

const iconMap = { Heart, Baby, Cake, GraduationCap, Plane, Gift, Lightbulb, Sparkles, Cloud, Stethoscope, LifeBuoy, AlertTriangle, Users, HandHeart };

function CategoryTile({ icon, label, accent, onClick }) {
  const Icon = iconMap[icon] || Sparkles;
  return (
    <button onClick={onClick} className="group bg-white border border-black/5 rounded-2xl py-4 px-2 flex flex-col items-center gap-2 hover:bg-neutral-50 hover:border-black/10 btn-anim">
      <Icon className="w-5 h-5" style={{ color: accent }} />
      <span className="text-[12.5px] text-neutral-700 font-medium">{label}</span>
    </button>
  );
}

export default function EmotionSection({ onCreate }) {
  const { requireAuth } = useAuth();
  const start = (type) => { if (requireAuth(`create-${type.toLowerCase()}`)) onCreate && onCreate(type); };

  return (
    <section id="joyeuse" className="relative">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="text-center max-w-3xl mx-auto">
          <div className="inline-block text-[11px] tracking-[0.18em] uppercase font-medium text-neutral-500">Pour quel moment ?</div>
          <h2 className="mt-3 text-[clamp(2rem,4vw,3.4rem)] leading-[1.05] font-semibold tracking-tight text-[#1a1d1a]">
            Choisissez votre <span className="serif-italic text-[#d97757]">émotion</span>.
          </h2>
          <p className="mt-4 text-[15.5px] text-neutral-600">
            Deux univers, une même solidarité. Que vous célébriez un événement heureux ou que vous traversiez une épreuve, Fodindin s'adapte au ton juste.
          </p>
        </div>

        <div className="mt-12 grid lg:grid-cols-2 gap-6">
          <div className="relative rounded-[28px] bg-gradient-to-br from-[#fff3ec] to-[#fde6d8] border border-[#d97757]/20 p-7 sm:p-8 overflow-hidden card-lift">
            <div className="absolute -top-12 -right-10 w-48 h-48 rounded-full bg-[#d97757]/10" />
            <div className="relative">
              <div className="inline-flex items-center gap-2 text-[11px] tracking-[0.16em] uppercase font-semibold text-[#d97757]">
                <Sparkles className="w-4 h-4" /> Cagnotte Joyeuse
              </div>
              <h3 className="mt-3 text-[28px] sm:text-[32px] font-semibold text-[#1a1d1a] leading-tight">Pour célébrer la vie</h3>
              <p className="mt-2 text-[14.5px] text-neutral-700 max-w-md">Mariages, naissances, anniversaires, diplômes, voyages, cadeaux groupés…</p>
              <div id="yako" className="mt-6 grid grid-cols-4 gap-2">
                {joyeuseCategories.map((c) => <CategoryTile key={c.label} icon={c.icon} label={c.label} accent="#d97757" onClick={() => start('Joyeuse')} />)}
              </div>
              <button onClick={() => start('Joyeuse')} className="mt-7 inline-flex items-center gap-1.5 font-semibold text-[#d97757] hover:gap-2.5 transition-all">
                Créer une Cagnotte Joyeuse <ArrowRight className="w-4 h-4" />
              </button>
            </div>
          </div>

          <div className="relative rounded-[28px] bg-gradient-to-br from-[#eaf1e7] to-[#d9e6d3] border border-[#5a8268]/20 p-7 sm:p-8 overflow-hidden card-lift">
            <div className="absolute -top-12 -right-10 w-48 h-48 rounded-full bg-[#5a8268]/10" />
            <div className="relative">
              <div className="inline-flex items-center gap-2 text-[11px] tracking-[0.16em] uppercase font-semibold text-[#5a8268]">
                <HandHeart className="w-4 h-4" /> Cagnotte Yako
              </div>
              <h3 className="mt-3 text-[28px] sm:text-[32px] font-semibold text-[#1a1d1a] leading-tight">Pour soutenir avec dignité</h3>
              <p className="mt-2 text-[14.5px] text-neutral-700 max-w-md">Obsèques, maladies, difficultés, sinistres, soutien aux familles…</p>
              <div className="mt-6 grid grid-cols-3 gap-2">
                {yakoCategories.map((c) => <CategoryTile key={c.label} icon={c.icon} label={c.label} accent="#5a8268" onClick={() => start('Yako')} />)}
              </div>
              <button onClick={() => start('Yako')} className="mt-7 inline-flex items-center gap-1.5 font-semibold text-[#5a8268] hover:gap-2.5 transition-all">
                Créer une Cagnotte Yako <ArrowRight className="w-4 h-4" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
